export interface User {
  id: string;
  username: string;
  emailAddress: string;
  firstName: string;
  lastName: string;
  customer: string;
  emailConfirmed: string;
  canDelete: boolean;
  roles: string;
  disabled: boolean;
  amendOtherComments: boolean;
}
